
export const DEPARTMENTS: string[] = [
	"2d63ee80-421b-488f-992a-0e07a3264c3e",
	"e1bfc996-da45-4859-ba11-8a1b73486d4e",
	"f539e1f7-0bd8-4277-943a-69234c45f3e5",
	"baa6a98e-3451-4ae9-b082-3e395a5f0504",
	"6899b232-a482-4fc7-98f8-21aa670bf4c1",
	"2af5dcde-96eb-4443-9c2b-feee714748cc",
	"209f5ed2-e25b-4039-ad3c-ae18bfceb1a1",
	"88ad5c3c-7f99-4842-9895-f6c94f3cfafd",
	"2eb97bf5-0c58-47be-b056-cd9e600b4ff7",
	"52a38847-9348-48c9-be79-1e54f6019de3",
	"2d9f0ad9-8b72-4364-a7dc-e161d7dddb4d",
    "a4f7acee-01dc-4d5d-9f3d-d34889813a16",
    "4424d062-08a1-4a23-9b6e-5d060f139915",
];

export const CITIES: string[] = [
    "183f0a11-9452-4160-9089-1b0e7ed45863", 
    "9feb0402-fc35-4538-8ca1-d53c0fec2c35",
    "241a17ef-3aa0-485c-93aa-689fc2f2d114",
    "596f30cb-3582-416e-a071-71634190a703", 
    "e18fae77-dbe2-492a-a675-a6682d0bcc26",
    "96668cf7-595b-4ec8-8d36-17806cdf4f51",
    "b8f0f380-18c4-49ee-a6b3-92b454846718",
    "22064a29-64d4-458e-be1d-04305a75c967",
    "cf5dc27a-9e05-4b0a-b98a-0715fe4e5d2b", 
    "317c1450-a8b1-46ef-83e3-bd2b0deb90a0", 
    "0affff3e-ec6a-421e-a2d4-8b198493cff9",
    "5499b608-1002-43a3-9215-01c40ffae22b",
    "6b101fd7-007f-41ce-a4f7-d96f0b61ecc3",
    "b6bcc960-092d-4d8e-ba8c-ba3cbdab4919",
    "0e99ce18-9ff5-4c20-9b60-6150cc9e094b",
    "395a55a6-c0b6-4c1d-87f2-32952c7a9def",
    "afeb5924-39f4-4b92-adb2-7977e89b5b9a",
    "d9f2c572-bee7-4c37-a9e7-7775c6dc45c6",
    "20e4ab13-1196-4be5-9652-543210844a04",
    "8870325f-b60f-4935-b57c-16600221cebe",
    "0878251d-1cee-40c5-a40d-ff6d59938a11",
    "b15da91a-40b9-4d43-a348-c42b457ce366",
    "ce59b563-0485-4e17-bcaa-b812252914e7",
    "b3acad3f-8375-4952-90eb-df5ee9cc08d9",
    "0f07ca63-61f4-498a-b650-06d359ac5bd3",
    "9315523c-12cc-4678-804d-d05e4cf174b4",
    "48e11032-4c19-473e-96b4-5ea59c4f13be",
    "15b50d59-ab91-4352-8aad-bc01118a5a8b",
    "3a7b12b4-ca80-4dbb-93d8-fbbed26e19f9",
    "9b5c9e81-e778-4c03-9e35-016e70c60652",
    "0f4c7911-6b55-4242-9c67-4226b7478fa0",
    "34936edd-312d-4876-ae6e-612e3049e70b",
    "05ccc280-20c7-4ebd-84a6-61a66da81d54",
    "0dd0a661-a8d5-4e4a-9b82-8eadc85f1bb5",
    "60e75889-1f10-405e-9304-e921d624c4e9",
    "d48b4a97-7531-4555-96b5-84b80691b81b",
    "3555407c-44ee-4032-aa22-50d715aaca37",
    "8186fa47-207f-441f-afb6-604138119718",
    "51e07952-3102-48fa-81e9-072472181e9d",
    "7df01cb3-23cc-460a-8f93-068c228e18c5",
    "b9bb5885-0229-4537-865c-cb19cb2b6bf6",
    "353f6a09-795f-4619-84e6-48cec5979268",
    "2f7ef78d-9b8a-4db5-a2a5-fb4ead7cbe52",
    "90b2292c-0a20-4d41-b3e4-378287c16494",
    "ca8e94ba-3a6c-459d-ba87-a0e29165f461",
    "7e60b07a-df5f-40b3-9349-a4b44d8041cc",
    "ec339020-940c-4226-888d-870c39186c80",
    "7e60b07a-df5f-40b3-9349-a4b44d8041cc",
    "9b147883-ba85-440e-9565-7e57804eb801",
    "051e8d21-4c64-41dc-9939-8155f124210b",
    "c6c6062c-d1b1-496d-be16-6bca350f10c0",
    "660ddecf-107f-4003-a9d0-9adff213204c",
    "b91caff7-de1a-41f3-b0ad-fc70e7b56949",
    "4114f274-a201-4a7c-8849-a6745b72179e",
    "12c5ed5f-7e88-45ca-a7f8-cdba01f849f0",
    "65d441f3-a239-4111-bc5b-01c5a268869f",
    "09534348-ff0e-481e-ba65-e35438949ddb",
    "e8394727-233d-4eef-afce-12f790b322ef",
    "00e271e4-b93f-4162-82c7-adf81d8a70e9",
    "e6cd17d1-e52f-474c-8e4c-330527bfb599",
    "855a4ead-f1ea-4e62-91e7-0b091c80a053",
    "ee89a5fd-2ea8-48ef-b982-88449a3bbfb1",
    "2c1ad9b5-d31f-475b-8486-a738fd1c6675",
    "35010fa4-a9a6-44a6-8587-13cec08b2d8c",
    "e98f01ae-d17c-43da-b7c2-e73ebc26c420",
    "ab3f0370-3ce7-4af5-b993-30f9e1366a21",
    "45e6e2e0-fbcb-479d-86eb-52cc39a8267a",
    "3c65d2e3-05c9-4d5d-b4b1-fecc1a4ec2f6",
];

export const STRATUM: number[] = [2, 3, 4];

export const PERCENT_OWN_RESOURCES_LOW = 0.25;
export const PERCENT_OWN_RESOURCES_HIGH = 0.3;
export const PERCENT_CREDIT_VALUE_LOW = 0.75;
export const PERCENT_CREDIT_VALUE_HIGH = 0.7;
export const MIN_VALUE = 90_000_000;
export const MID_VALUE = 195_000_000;
export const MAX_VALUE = 325_000_000;

